import React from 'react'
import { GoArrowRight } from 'react-icons/go'
import "./pages/Services.css"
import { Link } from 'react-router-dom'
import { TbLoader3 } from 'react-icons/tb'

function Button({btnTitle, link,handleSubmit,loading}) {
  return (

    <div className='btn-container'>
     {loading ? <TbLoader3 className='btn-loader'/>:<>
      {link ?     <Link to={link} className='hero-btn'>{btnTitle}</Link>
: <button type='submit' className='hero-btn'disabled={loading ? true:false}>
  {btnTitle}</button>}
   <GoArrowRight className='btn-icon'/>    <span className='btn-bg'></span>
  
     </>} 
    </div>)
}

export default Button